const constants = {
  NETWORK_NAME: process.env.REACT_APP_NETWORK_NAME,
  CHAIN_ID: process.env.REACT_APP_CHAIN_ID,
  CONTRACT_ADDRESS: process.env.REACT_APP_CONTRACT_ADDRESS || "",
  GAS_PRICE: process.env.REACT_APP_GAS_PRICE,
};

export default constants;
